var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"mt-5"},_vm._l((_vm.section.rows),function(row){return _c('Row',{key:row.row,attrs:{"row":row}})}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2449b14f","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/hiragana/RowList.vue
// module id = 87
// module chunks = 0